var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.loading
    ? _c(
        "div",
        { staticClass: "ci-card p-3 p-md-4", attrs: { id: "privacy-policy" } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", {
              ref: "contentRef",
              staticClass: "col-12 col-xxl-8 content-inner",
              domProps: { innerHTML: _vm._s(_vm.content) },
            }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }